import { getUserId } from './authStore';

/** Shared demo workspace owner (public config — not a secret). */
export const DEMO_USER_ID: string | null =
  typeof process.env.REACT_APP_DEMO_USER_ID === 'string' && process.env.REACT_APP_DEMO_USER_ID.trim()
    ? process.env.REACT_APP_DEMO_USER_ID.trim()
    : null;

let demoModeActive = false;

export function setDemoMode(active: boolean): void {
  demoModeActive = Boolean(active && DEMO_USER_ID);
}

export function isDemoMode(): boolean {
  return demoModeActive && Boolean(DEMO_USER_ID);
}

/** user_id for leads/projects/payments/calendar/templates queries. */
export function getDataUserId(): string | null {
  if (isDemoMode() && DEMO_USER_ID) return DEMO_USER_ID;
  return getUserId();
}

export const DEMO_READONLY_EVENT = 'leadsme:demo-readonly';

let lastReadonlyNotifyAt = 0;

/** Friendly toast: demo is read-only (debounced). */
export function notifyDemoReadonly(): void {
  if (typeof window === 'undefined') return;
  const now = Date.now();
  if (now - lastReadonlyNotifyAt <= 2500) return;
  lastReadonlyNotifyAt = now;
  window.dispatchEvent(new CustomEvent(DEMO_READONLY_EVENT));
}

/**
 * If demo mode: show toast and return true (caller must abort — no optimistic UI).
 * Otherwise return false.
 */
export function blockDemoWrite(): boolean {
  if (!isDemoMode()) return false;
  notifyDemoReadonly();
  return true;
}

/** Real auth user — null in demo mode (blocks writes). Prefer blockDemoWrite() in UI first. */
export function getWriteUserId(): string | null {
  if (isDemoMode()) {
    notifyDemoReadonly();
    return null;
  }
  return getUserId();
}
